import { render } from "./Witness.vue?vue&type=template&id=aba657f8"
import script from "./Witness.vue?vue&type=script&lang=js"
export * from "./Witness.vue?vue&type=script&lang=js"

import "./Witness.vue?vue&type=style&index=0&id=aba657f8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__